export const setHotelParams = (
	kinboo1Config: any,
	lang: any,
	kinboo2Config: any,
	region: string | null = null
) => {
	let params = {
		addParams: kinboo1Config?.addParams ?? "1",
		calculate: kinboo1Config?.calculate ?? "1",
		discountPromise: kinboo1Config?.discountPromise ?? "1",
		filterCategories: kinboo1Config?.filterCategories ?? "9",
		footer: kinboo1Config?.footer ?? "0",
		getOffers: kinboo1Config?.getOffers ?? "true",
		header: kinboo1Config?.header ?? "0",
		hotelDetailPageCssUrl:
			kinboo1Config?.hotelDetailPageCssUrl ??
			"https://example.com/custom-hotel.css",
		infopass: kinboo1Config?.infopass ?? "1",
		maxRooms: kinboo1Config?.maxRooms ?? "4",
		poiProductTypes: kinboo1Config?.poiProductTypes ?? "0|4",
		quotation: kinboo1Config?.quotation ?? "true",
		retrieveClient: kinboo1Config?.retrieveClient ?? "1",
		showHotelDetails: kinboo1Config?.showHotelDetails ?? "true",
		showRating: kinboo1Config?.showRating ?? "0",
		siteCssUrl:
			kinboo1Config?.siteCssUrl ?? "https://example.com/css/custom-site.css",
		structureDescription: kinboo1Config?.structureDescription ?? "1",
		template: kinboo1Config?.template ?? "charme_23",
		templateScheda: kinboo1Config?.templateScheda ?? "charme_restyle",
		transfer: kinboo1Config?.transfer ?? "1",
		b2b: false,
		endPoint: kinboo2Config.hotelBolEndpoints[lang],
		showLocations: kinboo2Config?.showLocations ?? false,
		showRegions: kinboo2Config?.showRegions ?? false,
		region: region ?? "2|20",
		widget: true
	};
	return params;
};
export const setKinboo2Params = (
	kinboo2Config: any,
	type: string,
	lang: any,
	region: string | null = null
) => {
	let params = {
		theme: kinboo2Config?.theme ?? "default",
		showLocations: kinboo2Config?.showLocations ?? false,
		showRegions: kinboo2Config?.showRegions ?? false,
		segmentation_category_id: kinboo2Config?.segmentationCategoryId ?? "00",
		tag_category_id:
			type === "hotels"
				? null
				: kinboo2Config[type+'TagCategoryId'],
		nResults: kinboo2Config.resultsNumber ?? "16",
		region: region ?? "2|20",
		radius: kinboo2Config.radius
			? type === "viaggismart"
				? kinboo2Config.radius
				: "20"
			: "",
		b2b: kinboo2Config?.b2b ?? false,
		endPoint:
			type === "experience"
				? kinboo2Config.experienceBolEndpoints[lang]
				: (type === 'viaggismart' ? kinboo2Config.smartTravelBolEndpoints[lang] : kinboo2Config.hotelBolEndpoints[lang]),
		widget: true
	};
	return params;
};
